import { render } from "./Welcome.vue?vue&type=template&id=5c9c544c"
import script from "./Welcome.vue?vue&type=script&lang=js"
export * from "./Welcome.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/dmp/releases/1776447368/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__